import { ROLES } from '@/api/routes/users/types';

export const INSTALLATION_FORMS_ROLES = [
  ROLES.FORMS_INSTALL_STATIC_DEVICE_SUBMIT,
  ROLES.FORMS_INSTALL_DIGITAL_BOX_SUBMIT,
  ROLES.FORMS_INSTALL_GPS_TRACKER_SUBMIT,
  ROLES.FORMS_INSTALL_BOX_ADV_SUBMIT,
  ROLES.FORMS_INSTALL_SIDES_ADV_SUBMIT,
  ROLES.FORMS_INSTALL_DEVICE_TABLE_SUBMIT,
  ROLES.FORMS_REMOVE_DEVICE_DYNAMIC_SUBMIT,
  ROLES.FORMS_REMOVE_DEVICE_STATIC_SUBMIT,
  ROLES.FORMS_REMOVE_DEVICE_GPS_TRACKER_SUBMIT,
  ROLES.FORMS_REMOVE_DEVICE_TABLET_SUBMIT,
  ROLES.FORMS_REMOVE_DEVICE_REMOVE_BOX_ADV_SUBMIT,
  ROLES.FORMS_REMOVE_DEVICE_REMOVE_SIDES_ADV_SUBMIT,
];

export const ACCESS_ROLES_FOR_MAP = [
  ROLES.DEVICE_NEW,
  ROLES.DEVICE_EDIT,
  ROLES.DEVICE_SSH_EDIT,
  ROLES.DEVICE_SCREEN_EDIT,
  ROLES.DEVICE_PARK_VIEW,
  ROLES.DEVICE_OPERATOR_VIEW,
  ROLES.DEVICE_SURFACETYPE_VIEW,
  ROLES.DEVICE_PROFILE_VIEW,
  ROLES.VIEW,
  ROLES.DEVICE_STATIC_ADV_ORG_VIEW,
];

export const ACCESS_ROLES_FOR_GRAPHICS_STATISTICS = [
  ROLES.VIEW,
  ROLES.STAT_VIEW,
  ROLES.STAT_BASIC_DEVICE_PROFILE_VIEW,
  ROLES.STAT_DEVICE_PROFILE_VIEW,
  ROLES.STAT_STATIC_ADV_ORG_VIEW,
];

export const ACCESS_ROLES_FOR_DIGITAL_STATISTICS = [
  ROLES.VIEW,
  ROLES.STAT_VIEW,
  ROLES.STAT_CAMPAIGN_ORG_VIEW,
  ROLES.STAT_DEVICE_PROFILE_VIEW,
];

export const ACCESS_ROLES_FOR_STATISTICS = [
  ROLES.VIEW,
  ROLES.STAT_VIEW,
  ROLES.STAT_CAMPAIGN_ORG_VIEW,
  ROLES.STAT_STATIC_ADV_ORG_VIEW,
];

export const ACCESS_ROLES_FOR_REPORTS = [
  ROLES.VIEW, ROLES.REPORT_VIEW,
];

export const ACCESS_ROLES_FOR_CAMPAIGNS = [
  ROLES.ADV_CAMPAIGN_ORG_VIEW,
  ROLES.ADV_CAMPAIGN_VIEW,
  ROLES.ADV_ORG_EDIT,
  ROLES.VIEW,
  ROLES.STATIC_ADV_ORG_VIEW,
];

export const ACCESS_ROLES_FOR_MODERATION = [
  ROLES.VIEW,
  ROLES.ADV_CAMPAIGN_VIEW,
  ROLES.ADV_CAMPAIGN_ORG_VIEW,
  ROLES.ADV_ORG_EDIT,
];